import React from "react";
import {Spinner as ReactSpinner} from   "react-bootstrap";

export default function Spinner() {
  return (
    <ReactSpinner animation="border" variant="primary" />
  );
}
